module.exports = __webpack_public_path__ + "fonts/Red_Hat_Text-300-latin-ext1.c1506c7.woff2";